import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  errorMessage: {
    // Typography
    fontSize: '1.4rem',
    color: colors.red[500],
    lineHeight: '2.4rem',
    // Layout
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    margin: '2rem 0 1rem',
  },
  validationIcon: {
    width: '5%',
    verticalAlign: '-0.18rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
